// Тема-независимые токены: типографика, отступы, радиусы, тени, анимации, z-index.
// Это «структурная» часть визуального языка — не зависит от light/dark. Цвета (тема-зависимые)
// объявлены отдельно в palette.ts. Каждый токен — CSS custom property + типизированное имя,
// чтобы компоненты ссылались на var(--…) и НЕ хардкодили значения (энфорс — тест темизации).
/** Шкала типографики. Семейство — системный sans + моноширинный для code/pre (FR-MSG-02). */
export const typography = {
    fontFamilyBase: "system-ui, -apple-system, 'Segoe UI', Roboto, Ubuntu, Cantarell, 'Helvetica Neue', Arial, sans-serif",
    fontFamilyMono: "ui-monospace, SFMono-Regular, 'SF Mono', Menlo, Consolas, 'Liberation Mono', monospace",
    // Размеры по 4-pt-родственной шкале (rem).
    fontXs: '0.6875rem', // 11px — время в пузыре, мелкие подписи
    fontSm: '0.8125rem', // 13px — превью списка, подписи
    fontMd: '0.9375rem', // 15px — основной текст интерфейса (кнопки, формы, меню)
    // 17px — текст сообщения и поле ввода (из форка «Наш.Чат» 03.11.2026: «текст в чатах мелковат»;
    // 17 — размер переписки в iOS «Сообщения»/Telegram). Отдельный токен, чтобы не раздувать весь UI.
    fontMessage: '1.0625rem',
    fontLg: '1.0625rem', // 17px — заголовки строк/шапки
    fontXl: '1.375rem', //  22px — крупные заголовки
    weightRegular: '400',
    weightMedium: '500',
    weightSemibold: '600',
    weightBold: '700',
    lineTight: '1.2',
    lineNormal: '1.35',
    lineRelaxed: '1.5',
};
/** 4-pt шкала отступов. */
export const spacing = {
    space1: '4px',
    space2: '8px',
    space3: '12px',
    space4: '16px',
    space5: '20px',
    space6: '24px',
    space7: '32px',
    space8: '40px',
};
/** Радиусы. `bubbleTail` — скруглённый «не-хвостовой» угол; срез под хвостик у автора. */
export const radii = {
    radiusBubble: '16px',
    radiusBubbleTail: '4px',
    radiusPill: '999px',
    radiusAvatar: '50%',
    radiusCard: '12px',
    radiusControl: '10px',
};
/** Тени (меню, просмотрщик, всплывающие карточки). */
export const shadows = {
    shadowMenu: '0 6px 24px rgba(0, 0, 0, 0.18)',
    shadowViewer: '0 10px 40px rgba(0, 0, 0, 0.45)',
    shadowCard: '0 1px 3px rgba(0, 0, 0, 0.12)',
};
/** Длительности/кривые анимаций (§0b «плавные переходы/анимации»). */
export const motion = {
    motionFast: '120ms',
    motionNormal: '220ms',
    motionSlow: '320ms',
    easeStandard: 'cubic-bezier(0.2, 0, 0, 1)',
    easeDecelerate: 'cubic-bezier(0, 0, 0, 1)',
};
/** z-index слои: меню < просмотрщик < тост (тост поверх всего). */
export const zLayers = {
    zBase: '0',
    zSticky: '10', // sticky-разделители дат
    zMenu: '100', // контекст-меню / поповеры
    zSheet: '200', // нижние шторки / модалки
    zViewer: '300', // полноэкранный просмотрщик медиа
    zToast: '400', // тосты поверх всего
};
/** Один словарь «логическое имя → значение» для структурных (тема-независимых) токенов. */
export const scaleTokens = {
    ...typography,
    ...spacing,
    ...radii,
    ...shadows,
    ...motion,
    ...zLayers,
};
/**
 * camelCase → kebab-case CSS-имя: `fontMd` → `--font-md`, `space4` → `--space-4`,
 * `radiusBubbleTail` → `--radius-bubble-tail`. Чистая, детерминированная — основа реестра CSS-vars.
 */
export function cssVarNameOf(token) {
    const kebab = token
        // граница «буква→цифра» (space4 → space-4)
        .replace(/([a-z])([0-9])/g, '$1-$2')
        // граница «строчная/цифра → Заглавная» (fontMd → font-Md, radiusBubble → radius-Bubble)
        .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
        .toLowerCase();
    return `--${kebab}`;
}
//# sourceMappingURL=scale.js.map